module.exports = __webpack_public_path__ + "img/Taken.4acc3aa3.png";